import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Called if the payment method tokenization did not start. Receives a `}<inlineCode parentName="p">{`reason`}</inlineCode>{` as a string.`}</p>
    <Group summary='Parameters' mdxType="Group">
      <Item title='reason' subtitle='"TOKENIZATION_SHOULD_NOT_START" | "TOKENIZATION_DISABLED"' mdxType="Item">
        <ul>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`TOKENIZATION_SHOULD_NOT_START`}</inlineCode>{`: tokenization was interrupted returning `}<inlineCode parentName="p">{`false`}</inlineCode>{` from `}<inlineCode parentName="p">{`onTokenizeShouldStart`}</inlineCode>{`.`}</p>
          </li>
          <li parentName="ul">
            <p parentName="li"><inlineCode parentName="p">{`TOKENIZATION_DISABLED`}</inlineCode>{`: tokenization was disabled using `}<inlineCode parentName="p">{`setIsTokenizationEnabled`}</inlineCode>{` or `}<inlineCode parentName="p">{`setPaymentCreationEnabled`}</inlineCode>{`.`}</p>
          </li>
        </ul>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      